var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPendingIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 18 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#pending-icon_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15.7 9.01c0 3.667-3 6.64-6.6 6.64-3.7 0-6.7-2.973-6.7-6.64 0-3.668 3-6.641 6.7-6.641 3.6 0 6.6 2.973 6.6 6.641Zm1.7 0c0 4.584-3.8 8.3-8.3 8.3a8.29 8.29 0 0 1-8.3-8.3A8.29 8.29 0 0 1 9.1.709c4.5 0 8.3 3.716 8.3 8.301ZM9.9 4.859c0-.458-.4-.83-.8-.83-.5 0-.9.372-.9.83V9.01a.7.7 0 0 0 .4.664l3.3 2.49c.3.275.9.2 1.1-.166.3-.367.2-.887-.1-1.162l-3-2.241V4.859Z",
  fill: "currentColor"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "pending-icon_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  transform: "translate(.5)",
  d: "M0 0h17v18H0z"
})))));
export default SvgPendingIcon;